export const typography = {
  microCopy: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    textDecoration: "none",
  },
  linkUnderline: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "24px",
    textDecoration: "underline",
  },
  link: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none",
  },
  label: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    textDecoration: "none",
  },
  button: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none",
  },
  paragraphSmall: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    textDecoration: "none",
  },
  paragraphLarge: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none",
  },
  subheading: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none",
  },
  headingSmall: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "24px",
  },
  headingMedium: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "32px",
    textDecoration: "none",
  },
  headingLarge: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "32px",
    textDecoration: "none",
  },
  headingXLarge: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: "32px",
    lineHeight: "48px",
    textDecoration: "none",
  },
  headingDisplay: {
    fontFamily: "'Nexa Text', sans-serif",
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "48px",
    lineHeight: "64px",
    textDecoration: "none",
  },
} as const;

export type TypographyKeys = keyof typeof typography;

export type Typography = {
  fontFamily: string
  fontStyle: string
  fontWeight: number
  fontSize: string
  lineHeight: string
  textDecoration: string
};
